const CONTACT_LABELS = ["BUSINESS", "HOME", "MAIL", "MOBILE", "OTHER"];

export default CONTACT_LABELS;
